import Address from './Address';
import Age from './Age';
import { Bic } from './Bic';
import Choice from './Choice';
import CodeMirrorCell from './CodeMirror';
import Collection from './Collection';
import Color from './Color';
import Date from './Date';
import DateInterval from './DateInterval';
import DateRange from './DateRange';
import Default from './Default';
import DueDate from './DueDate';
import Email from './Email';
import EmailWithContent from './EmailWithContent';
import File from './File';
import FilePath from './FilePath';
import Hash from './Hash';
import MilitaryTime from './MilitaryTime';
import Money from './Money';
import Multiline from './Multiline';
import Number from './Number';
import OpeningTimes from './OpeningTimes';
import Percentage from './Percentage';
import Phone from './Phone';
import PriceCharge from './PriceCharge';
import PriceSet from './PriceSet';
import { ReferenceDisplay } from './Reference';
import CellTable from './CellTable';
import Time from './Time';
import Translateable from './Translateable';
import Translated from './Translated';
import Url from './Url';
import Boolean from './Boolean';
import { renderAureliaCell } from './AureliaCell';

export const getFieldRenderer = (field) => {
    if (!field.type && !field.template) {
        return (params) => {
            return <Default params={params} field={field} />;
        };
    }
    if (!field.type && field.template) {
        return (params) => {
            return renderAureliaCell(params, field);
        };
    }

    switch (field.type) {
        case 'string':
            return (params) => {
                return <Default params={params} field={field} />;
            };
        case 'email':
            return (params) => {
                return <Email params={params} />;
            };
        case 'email-with-content':
            return (params) => {
                return <EmailWithContent params={params} />;
            };
        case 'address':
            return (params) => {
                return <Address field={field} params={params} />;
            };
        case 'reference':
            return (params) => {
                return (
                    <ReferenceDisplay reference={params?.value} field={field} />
                );
            };

        case 'phone':
            return (params) => {
                return <Phone params={params} />;
            };
        case 'collection':
            if (field.property == 'phones') {
                return (params) => {
                    return <Phone params={params} />;
                };
            } else {
                return (params) => {
                    return <Collection params={params} field={field} />;
                };
            }
        case 'date':
            return (params) => <Date params={params} field={field} />;
        case 'number':
            return (params) => <Number params={params} field={field} />;
        case 'boolean':
            return (params) => {
                return <Boolean params={params} />;
            };
        case 'translatable':
            return (params) => {
                return <Translateable params={params} field={field} />;
            };
        case 'translatable-slug':
            return (params) => {
                return <Translateable params={params} field={field} />;
            };
        case 'bic':
            return (params) => {
                return <Bic params={params} field={field} />;
            };
        case 'age':
            return (params) => {
                return <Age params={params} field={field} />;
            };
        case 'choice':
            return (params) => {
                return <Choice params={params} field={field} />;
            };
        case 'opening-times':
            return (params) => {
                return <OpeningTimes params={params} field={field} />;
            };
        case 'color':
            return (params) => {
                return <Color params={params} field={field} />;
            };
        case 'dueDate':
            return (params) => {
                return <DueDate params={params} field={field} />;
            };
        case 'url':
            return (params) => {
                return <Url params={params} />;
            };

        case 'file-path':
            return (params) => {
                return <FilePath params={params} field={field} />;
            };
        case 'file':
            return (params) => {
                return <File params={params} field={field} />;
            };
        case 'money':
            return (params) => {
                return <Money params={params} field={field} />;
            };
        case 'percentage':
            return (params) => {
                return <Percentage params={params} field={field} />;
            };
        case 'price-charge':
            return (params) => {
                return <PriceCharge params={params} field={field} />;
            };
        case 'military-time':
            return (params) => {
                return <MilitaryTime params={params} field={field} />;
            };
        case 'date-interval':
            return (params) => {
                return <DateInterval params={params} field={field} />;
            };
        case 'multiline':
            return (params) => {
                return <Multiline params={params} field={field} />;
            };
        case 'codemirror':
            return (params) => {
                return <CodeMirrorCell params={params} field={field} />;
            };
        case 'time':
            return (params) => {
                return <Time params={params} field={field} />;
            };
        case 'price-set':
            return (params) => {
                return <PriceSet params={params} field={field} />;
            };

        case 'translated':
            return (params) => {
                return <Translated params={params} field={field} />;
            };
        case 'date-range':
            return (params) => {
                return <DateRange params={params} field={field} />;
            };
        case 'hash':
            return (params) => {
                return <Hash params={params} field={field} />;
            };
        case 'table':
            return (params) => {
                return <CellTable params={params} field={field} />;
            };
        default:
            return (params) => {
                return <Default params={params} field={field} />;
            };
    }
};
